import { createFileRoute } from "@tanstack/react-router";
import MagnusMedicalPage from "@/pages/MagnusMedicalPage";
export const Route = createFileRoute("/magnus-medical")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Magnus Medical SAINT® Technology | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Learn how Magnus Medical's FDA-cleared SAINT® Neuromodulation System provides 5-day rapid remission for treatment-resistant depression using fMRI-guided.",
        },
        {
          property: "og:title",
          content: "Magnus Medical SAINT® Technology | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Learn how Magnus Medical's FDA-cleared SAINT® Neuromodulation System provides 5-day rapid remission for treatment-resistant depression using fMRI-guided.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/magnus-medical",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/magnus-medical",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <MagnusMedicalPage />;
}
